import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class MultiquoteCarPermissions extends BaseScenesPermissions {}

export default MultiquoteCarPermissions
